export const EXP_CTA_TEXT = "See experience";



// WEBPACK FOOTER //
// ./src/constants/general.js